import _ from 'lodash'
import { ActionTypes, types } from './cart.types'
import { CartInterface, DEFAULT_CART_PAYMENT_LIMITS } from '../../interfaces/CartInterface'
import { ChannelSiteInterface } from '../../interfaces/ChannelInterface'

export interface State extends CartInterface {}

export const initialState: Readonly<State> = {
  id: null,
  status: 1,
  currency: '',
  itemCount: false,
  totalItemsNet: '',
  totalItemsGross: '',
  totalItemsTax: '',
  totalNet: '',
  totalGross: '',
  totalTax: '',
  shippingCostNet: '',
  shippingCostGross: '',
  userId: null,
  createdAt: '',
  submittedAt: '',
  exchangeRate: '',
  locale: '',
  valid: false,
  errors: [],
  items: [],
  shippingMethod: null,
  billingAddress: null,
  shippingAddress: null,
  discounts: [],
  totalDiscountNet: '',
  totalDiscountGross: '',
  payments: [],
  gifts: null,
  requiredPayment: '',
  deliveryNotice: null,
  authorityToLeave: undefined,
  type: null,
  channelEntry: {} as ChannelSiteInterface,
  paymentLimits: DEFAULT_CART_PAYMENT_LIMITS,
  forcedCountry: null,
  partialDiscountGross: null,
  returnFlow: null,
  recipientInfo: null,
  isGift: false,
}

export default function cartReducer(state: State = initialState, action: ActionTypes) {
  switch (action.type) {
    case types.UPDATE_SUCCESS: {
      let newState = _.clone(state)
      newState = {
        ...action.payload,
        paymentLimits: {
          ...DEFAULT_CART_PAYMENT_LIMITS,
          ...(action.payload.paymentsLimit ? { card: action.payload.paymentsLimit } : {}),
          ...(action.payload.paymentLimits ? action.payload.paymentLimits : {}),
        },
      }
      return newState
    }

    case types.DELETE_SUCCESS: {
      const newState = _.clone(initialState)
      return newState
    }

    default: {
      return state
    }
  }

  return state
}
